<template>
  <section class="section" id="transactions-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <transactions-title
        :transactionsQty="transactionsReverse.length"
        :storeId="selectedStoreId"
        :storeName="selectedStoreName"
        @update-dates="updateDates"
        @update-store="updateStore"
        @get-transactions="getTransactions"
        @download-transactions-report="downloadTransactionsReport"
      />

      <h2
        v-if="transactionsReverse.length === 0"
        class="subtitle has-text-centered"
      >
        {{ $t("transactions.noTransactionsAtThisTime") }}
      </h2>

      <div v-else>
        <transactions-summary
          :transactions="transactionsReverse"
          v-if="permissions.seeTransactionsSummary"
        />

        <transactions-table
          :transactions="transactionsReverse"
          :gouOrder="selectedStoreGouOrder"
          @loading="isLoading = $event"
          @get-transactions="getTransactions"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import transactionsTitle from "./TransactionsTitle";
import transactionsSummary from "./transactions-summary/TransactionsSummary";
import transactionsTable from "./transactions-table/TransactionsTable";

export default {
  mixins: [common, mask],

  components: {
    transactionsTitle,
    transactionsSummary,
    transactionsTable
  },

  data() {
    return {
      isLoading: false,
      dates: [],
      store: undefined,
      storeName: null
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "transactionsReverse", "permissions"]),

    isAllStoresMode() {
      return this.$route.query.allStores === "true";
    },

    selectedStoreId() {
      return this.isAllStoresMode ||
        !this.storeBeingManaged ||
        !this.storeBeingManaged._id
        ? null
        : this.storeBeingManaged._id;
    },

    selectedStoreName() {
      return this.isAllStoresMode ||
        !this.storeBeingManaged ||
        !this.storeBeingManaged.storeInfo
        ? this.$t("transactions.allStores")
        : this.storeBeingManaged.storeInfo.name;
    },

    selectedStoreGouOrder() {
      return this.isAllStoresMode ||
        !this.storeBeingManaged ||
        !this.storeBeingManaged.configs
        ? false
        : this.storeBeingManaged.configs.gouOrder;
    },

    approvedTransactions() {
      return this.transactionsReverse.filter(t => {
        return t.details.status === "success";
      }).length;
    },

    totalValue() {
      return this.transactionsReverse.length
        ? this.transactionsReverse
            .filter(t => {
              return t.details.status === "success";
            })
            .reduce((totalValue, t) => {
              return (totalValue += t.cart.totalValue);
            }, 0)
        : 0;
    }
  },

  methods: {
    getTransactions(omitLoading) {
      if (!omitLoading) this.isLoading = true;

      this.$store
        .dispatch("getTransactions", {
          storeId: this.store,
          dates: this.dates
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadTransactionsReport(reportModel) {
      this.isLoading = true;
      this.$store
        .dispatch("downloadTransactionsReport", {
          storeName: this.storeName,
          storeId: this.store,
          dates: this.dates,
          reportModel
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateDates(dates) {
      this.dates[0] = dates
        ? this.moment(dates[0]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");

      this.dates[1] = dates
        ? this.moment(dates[1]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");
    },

    updateStore(store) {
      this.store = store ? store.split("|")[0] : "";
      this.storeName = store
        ? store.split("|")[1]
        : this.$t("transactions.allStores");
    }
  },

  mounted() {
    this.updateDates();
    this.getTransactions();
  },

  created() {
    if (
      this.isAllStoresMode ||
      !this.storeBeingManaged ||
      !this.storeBeingManaged._id ||
      !this.storeBeingManaged.storeInfo
    ) {
      this.store = "";
      this.storeName = this.$t("transactions.allStores");
      return;
    }

    this.store = this.storeBeingManaged._id;
    this.storeName = this.storeBeingManaged.storeInfo.name;
  }
};
</script>

<style scoped>
#transactions-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
